import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-694c3083")

_pushScopeId("data-v-694c3083")
const _hoisted_1 = { class: "w-full tracking-height overflow-y-auto pb-8 relative" }
const _hoisted_2 = { class: "w-full mt-8 flex flex-row justify-start items-center gap-x-3" }
const _hoisted_3 = { class: "w-350px" }
const _hoisted_4 = {
  key: 0,
  class: "w-full flex flex-col pt-8"
}
const _hoisted_5 = {
  key: 0,
  class: "empty-state h-full"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col mt-8 gap-y-5"
}
const _hoisted_7 = { class: "border border-gray-lp-400 shadow-sm overflow-y-auto rounded-xl p-5 overflow-x-hidden" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-y-5" }
const _hoisted_9 = { class: "col-span-2 text-black-lp-300 text-20px font-semibold" }
const _hoisted_10 = { class: "w-full overflow-x-auto col-span-2" }
const _hoisted_11 = { class: "text-black-lp-300 table table-cargo-min-width" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "border border-gray-lp-400 shadow-sm rounded-xl p-5"
}
const _hoisted_14 = { class: "grid grid-cols-2 gap-y-5" }
const _hoisted_15 = { class: "col-span-2 text-black-lp-300 text-20px font-semibold" }
const _hoisted_16 = { class: "w-full overflow-x-auto col-span-2" }
const _hoisted_17 = { class: "text-black-lp-300 table table-cargo-history-min-width" }
const _hoisted_18 = {
  key: 3,
  class: "flex flex-row gap-x-3 absolute border border-gray-lp-400 shadow-md p-4 rounded-md items-start bg-white",
  style: {"top":"15px","right":"2px"}
}
const _hoisted_19 = { class: "flex flex-col gap-y-2 text-12px xxl:text-14px max-w-xs" }
const _hoisted_20 = { class: "text-black-lp-300 font-semibold" }
const _hoisted_21 = { class: "text-gray-lp-600" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_lp_input, {
          placeholder: _ctx.$t('placeholderCargoColumn'),
          modelValue: _ctx.cargoNo,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cargoNo = $event)),
          onChange: _ctx.handleErrorCargoNo,
          error: _ctx.isErrorCargoNo,
          disabled: false,
          errorIcon: false,
          onEnter: _ctx.trackCargo
        }, null, 8, ["placeholder", "modelValue", "onChange", "error", "onEnter"])
      ]),
      _createVNode(_component_lp_button, {
        disabled: !_ctx.cargoNo,
        title: _ctx.$t('trackingCargo.buttonTracking'),
        textColor: "white",
        onClick: _ctx.trackCargo
      }, null, 8, ["disabled", "title", "onClick"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_skeleton, {
            width: "600px",
            height: "40px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-10",
            width: "800px",
            height: "40px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "700px",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "500px",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "800px",
            height: "20px"
          })
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (!_ctx.isLoading && !_ctx.showCargoDetail && !_ctx.isError)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_EmptyState, {
                  customHeaderMessage: _ctx.errorHedearMessage,
                  data: _ctx.messageEmptyState
                }, null, 8, ["customHeaderMessage", "data"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoading && _ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 1,
                errorImage: _ctx.alertMessage.image,
                errorTitle: _ctx.alertMessage.title,
                errorMessage: _ctx.alertMessage.message,
                errorType: _ctx.errorCause,
                onTryAgain: 
          _ctx.errorCause === 'internet' || _ctx.errorCause === 'server'
            ? _ctx.trackCargo
            : null
        
              }, null, 8, ["errorImage", "errorTitle", "errorMessage", "errorType", "onTryAgain"]))
            : _createCommentVNode("", true),
          (_ctx.showCargoDetail && !_ctx.isLoading && !_ctx.isError)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("Detail Kargo")), 1),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode(_component_TableV2, {
                          style: {"margin-top":"0"},
                          columns: _ctx.columns,
                          data: _ctx.detailCargo,
                          pagination: _ctx.pagination,
                          borderTop: false,
                          borderBottom: false,
                          isNoPaddingBottom: "",
                          hidePagination: ""
                        }, null, 8, ["columns", "data", "pagination"])
                      ])
                    ]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('Kota Asal'),
                      value: _ctx.trackingCargoData.cargoOriginCityName,
                      class: "pl-4"
                    }, null, 8, ["label", "value"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('Kota Tujuan'),
                      value: _ctx.trackingCargoData.cargoDestinationCityName,
                      class: "pl-4"
                    }, null, 8, ["label", "value"]),
                    _hoisted_12,
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('Tipe Kota Tujuan'),
                      value: _ctx.trackingCargoData.cargoDestinationDistrictType,
                      class: "pl-4 capitalize"
                    }, null, 8, ["label", "value"])
                  ])
                ]),
                (
            _ctx.showCargoDetail &&
              !_ctx.isLoading &&
              !_ctx.isError &&
              _ctx.shipmentHistory.length > 0 &&
              _ctx.trackingCargoData.cargoType === 'plane'
          )
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('Riwayat Pengiriman')), 1),
                        _createVNode("div", _hoisted_16, [
                          _createVNode("div", _hoisted_17, [
                            _createVNode(_component_TableV2, {
                              style: {"margin-top":"0"},
                              columns: _ctx.columnsHistory,
                              data: _ctx.shipmentHistory,
                              pagination: _ctx.pagination,
                              hidePagination: ""
                            }, null, 8, ["columns", "data", "pagination"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowAlertMessage)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode("img", {
                  src: require('@/app/ui/assets/svg/exclamation-yellow.svg'),
                  class: "w-6 max-w-none",
                  alt: "exclamation-yellow"
                }, null, 8, ["src"]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("p", _hoisted_20, _toDisplayString(_ctx.alertMessage.title), 1),
                  _createVNode("p", _hoisted_21, _toDisplayString(_ctx.alertMessage.message), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
})